module.exports = __webpack_public_path__ + "static/img/malicious-actor.5d353cc0.svg";